var map = {
	"./batch/index.js": 1250,
	"./form/index.js": 1265,
	"./info/index.js": 1277,
	"./inventory/index.js": 1296
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2751;


//////////////////
// WEBPACK FOOTER
// ./src/components/app/registration/product \.\/[^\/]+\/index\.jsx?$
// module id = 2751
// module chunks = 0